// extracted by mini-css-extract-plugin
module.exports = {"container":"TreatmentCardPrice_container__IvxE2","prefix":"TreatmentCardPrice_prefix__45Q_y","price":"TreatmentCardPrice_price__jtI_j"};